var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("PageLayoutForms", {
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function() {
          return [
            _c(
              "h1",
              {
                staticClass:
                  "pdp-mandate-onboarding__title typographies-heading-h1"
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t.__("pdp.mandate.Onboarding.title")) +
                    "\n        "
                )
              ]
            )
          ]
        },
        proxy: true
      },
      {
        key: "sidebar-left",
        fn: function() {
          return [_c("OnboardingSidebar")]
        },
        proxy: true
      },
      {
        key: "content",
        fn: function() {
          return [
            _c("CompassInformationBanner", {
              attrs: {
                title: _vm.$t.__(
                  "pdp.mandate.Onboarding.InformationBanner.title"
                ),
                sourceIllustration:
                  "/ressources/logged/img/illustrations/pdp/invoicing-blocked.svg"
              },
              scopedSlots: _vm._u([
                {
                  key: "description",
                  fn: function() {
                    return [
                      _c("div", {
                        staticClass:
                          "pdp-mandate-onboarding__information typographies-paragraph-medium-regular",
                        domProps: {
                          innerHTML: _vm._s(_vm.informationBannerDescription)
                        }
                      })
                    ]
                  },
                  proxy: true
                }
              ])
            }),
            _vm._v(" "),
            _vm.isAdmin
              ? [
                  _c(
                    "h2",
                    {
                      staticClass:
                        "pdp-mandate-onboarding__subtitle typographies-heading-h2"
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t.__("pdp.mandate.Onboarding.subtitle")) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "pdp-mandate-onboarding__choices" },
                    _vm._l(["issue", "receipt"], function(choice) {
                      return _c("OnboardingChoice", {
                        key: choice,
                        attrs: {
                          type: choice,
                          disabled:
                            _vm.disableMandateType && choice === "issue",
                          state: _vm.choiceState(choice)
                        },
                        on: {
                          select: function(selected) {
                            return (_vm.localMandateType = selected)
                          }
                        }
                      })
                    }),
                    1
                  )
                ]
              : _c("CompassEmptyState", {
                  attrs: {
                    title: _vm.$t.__("pdp.mandate.Onboarding.EmptyState.title"),
                    caption: _vm.$t.__(
                      "pdp.mandate.Onboarding.EmptyState.caption"
                    ),
                    illustrationPath:
                      "/ressources/logged/img/illustrations/contact-unlocked.svg"
                  }
                })
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [
            _c("FooterFullPage", {
              attrs: {
                primaryAction: _vm.primaryAction,
                secondaryActions: _vm.secondaryActions
              }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }